import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Getting Started with Gatsby"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "getting-started-with-gatsby"
    }}>{`Getting Started with Gatsby`}</h1>
    <p>{`To use Theme UI with `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com"
      }}>{`Gatsby`}</a>{`, install and use `}<a parentName="p" {...{
        "href": "/packages/gatsby-plugin"
      }}><inlineCode parentName="a">{`gatsby-plugin-theme-ui`}</inlineCode></a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i theme-ui gatsby-plugin-theme-ui @emotion/react @emotion/styled @mdx-js/react@v1
`}</code></pre>
    <p>{`Add the plugin to your `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`module.exports = {
  plugins: ['gatsby-plugin-theme-ui'],
}
`}</code></pre>
    <p>{`Create a theme file located at `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/index.js`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme file
const theme = {
  colors: {
    text: '#000',
    background: '#fff',
  },
}

export default theme
`}</code></pre>
    <p>{`With `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui`}</inlineCode>{`, there is no need to manually use the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component.
Use the `}<a parentName="p" {...{
        "href": "/sx-prop"
      }}><inlineCode parentName="a">{`sx`}</inlineCode>{` prop`}</a>{`, `}<a parentName="p" {...{
        "href": "/color-modes"
      }}>{`color modes`}</a>{`, and other features just as you would with any other application.`}</p>
    <p>{`For more information, see the documentation for `}<a parentName="p" {...{
        "href": "/packages/gatsby-plugin"
      }}><inlineCode parentName="a">{`gatsby-plugin-theme-ui`}</inlineCode></a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      